export const fileServiceEndpoint = process.env.REACT_APP_FILE_SERVICE;
